import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import useNotificationsConfig, { NotificationProps } from './useNotificationsConfig';

const NotificationConfig = () => {
  // const theme = useTheme();

  const hook = useNotificationsConfig();

  return (
    <Box sx={{ paddingTop: '1rem', width: '100%' }}>
      {/* Nombre de empresa a mostrar en notificaciones a clientes. Comentado de forma temporal hasta tener servicio. */}
      {/* <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          width: '100%',
          [theme.breakpoints.between('lg', 'xl')]: { flexDirection: 'column', alignItems: 'start' },
          [theme.breakpoints.down('sm')]: { flexDirection: 'column', alignItems: 'start' },
        }}
      >
        <InputField
          label="Empresa a mostrar"
          name="companyNameToShow"
          type="text"
          tooltipText="Este es el nombre que verán sus clientes cuando le lleguen las notificaciones."
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
        />
        <Button
          variant="contained"
          sx={{
            marginTop: '52px',
            [theme.breakpoints.between('lg', 'xl')]: {
              marginTop: '0',
            },
            [theme.breakpoints.down('sm')]: { marginTop: '0' },
          }}
        >
          Actualizar
        </Button>
      </Box> */}

      {hook.notifications.map((section) => {
        return (
          <Sections
            title={section.title}
            options={section.options}
            onChgOption={hook.updateNotifications}
          />
        );
      })}
    </Box>
  );
};

export default NotificationConfig;

const Sections = ({ title, options, onChgOption }: NotificationProps) => {
  const theme = useTheme();
  return (
    <>
      <Typography
        variant="body1"
        sx={{ margin: '2rem 0', color: theme.palette.secondary.main, fontWeight: 600 }}
      >
        {title}
      </Typography>
      {options.map((option) => (
        <Box
          onClick={() => onChgOption(option.id, !option.enabled)}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography variant="body2" sx={{ fontWeight: '500' }}>
            {option.description}
          </Typography>
          <Switch checked={option.enabled} />
        </Box>
      ))}
    </>
  );
};
